import ApiService from '../ApiService';
const { REACT_APP_REST_ENDPOINT } = process.env;
export default class LezioniService {
  
  static getLezioniByIdClasse = (idClasse) => {
    return new Promise((resolve, reject) => { 
      let url = `${REACT_APP_REST_ENDPOINT}/lezioni/getByIdClasse`;
      return ApiService.postRequest(resolve, reject, url, idClasse);
    })
  };

  static getLezioneById = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/lezioni/show`;
      ApiService.getRequest(resolve, reject, url, id);
    });
  };

  static createLezione = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/lezioni/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteLezione = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/lezioni/delete`;
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateLezione = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/lezioni/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}
